import React, { useState } from "react";
import Container from "../../../components/Layout/Container";
import { QueryClient, QueryClientProvider } from "react-query";
import Landing from "./components/Landing";
import Category from "./components/Category";
import RunningLine from "./components/RunningLine";
import FeaturedCategoryProducts from "./components/FeaturedCategoryProducts";
import PromotionPopups from "./components/PromotionPopups";

export const queryClient = new QueryClient();
export default function FeaturesPage({ match }) {
  const [tabId, setTabId] = useState("landing");

  const breadcrumbLabels = {
    landing: "Landing banners",
    category: "Category banners",
    runningLine: "Running Line banners",
    featuredCategoryProducts: "Featured category products",
    promotionPopups: "Promotion popups",
  };

  const breadcrumbs = [
    { label: "Marketing", value: "/marketing" },
    { label: "Features", value: "/marketing/features" },
    {
      label: breadcrumbLabels[tabId],
      value: `/marketing/features/${tabId}`,
    },
  ];

  return (
    <Container
      location={{
        locationName: breadcrumbLabels[tabId],
        locationUrl: match.url,
      }}
      breadcrumbs={breadcrumbs}
    >
      <QueryClientProvider client={queryClient}>
        {tabId === "landing" && (
          <Landing key={tabId} tabId={tabId} setTabId={setTabId} />
        )}
        {tabId === "category" && (
          <Category key={tabId} tabId={tabId} setTabId={setTabId} />
        )}
        {tabId === "runningLine" && (
          <RunningLine key={tabId} tabId={tabId} setTabId={setTabId} />
        )}
        {tabId === "featuredCategoryProducts" && (
          <FeaturedCategoryProducts
            key={tabId}
            tabId={tabId}
            setTabId={setTabId}
          />
        )}
        {tabId === "promotionPopups" && (
          <PromotionPopups key={tabId} tabId={tabId} setTabId={setTabId} />
        )}
      </QueryClientProvider>
    </Container>
  );
}
